import { Box, LinearProgress, Typography } from "@mui/material";
import PropTypes from 'prop-types';

export const LinearProgressWithLabel = (/** @type {{ value: number; label: string ; variant: string}} */ props) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress sx={{
                    height: 20, backgroundColor: '#48657c33',
                    ['& .MuiLinearProgress-barColorPrimary']: {background: props.variant === 'winner' ? 'linear-gradient(to right, #4494fd,#006efe)' : 'linear-gradient(to right, #f7fbff,#90caf9)' }
                }} variant="determinate" value={props.value} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: props.variant === 'winner' ? 'bold' : undefined }}>{props.label}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.defaultProps = {
    variant: undefined,
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    variant: PropTypes.string,
}